import { lifecycle } from 'recompose';

const FetchOnMount = lifecycle({
  componentDidMount() {
    this.props.fetchData();
  },
});

export default FetchOnMount;



// WEBPACK FOOTER //
// ./src/app/hoc/FetchOnMount.js